import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Payroll} from '@app/core/models/payroll.model';
import {Observable} from 'rxjs';
import {Pagination, PaginationHolder} from '@app/core/models/pagination.model';
import {ICalculation, ICalculations} from '@app/core/interfaces/salary';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {map} from 'rxjs/operators';
import {IShiftCount} from '@app/core/interfaces/shiftCount';

@Injectable()
export class PayrollService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public getPayrolls(page: number, page_size: number, search_query: string): Observable<PaginationHolder<Payroll>> {

		return this.httpService.getJson('payrolls', {page, page_size, search_query}).pipe(map((res: PaginationHolder<Payroll>) => {
			res.pagination = new Pagination().deserialize(res.pagination);

			return res;
		}));
	}

	public getPayroll(id: number): Observable<Payroll> {
		return this.httpService.getJson<Payroll>('payrolls/' + id);
	}

	public createPayroll(payload: IQMNewSalaryExportData): Observable<Payroll> {
		return this.httpService.postJson<Payroll>('payrolls', payload);
	}

	public getShiftCount(payload: IQMShiftCountData): Observable<IShiftCount> {
		return this.httpService.postJson<IShiftCount>('payrolls/shiftCount', payload);
	}

	public getShiftCalculations(year: number, month: number, department_id): Observable<ICalculations> {
		return this.httpService.getJson<ICalculations>('salary/departments/' + department_id, {year, month});
	}

	public getShiftCalculation(year: number, month: number, department_id, user_id: number): Observable<ICalculation> {
		return this.httpService.getJson<ICalculation>('salary/departments/' + department_id + '/users/' + user_id, {year, month, include_shifts: true});
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}
}

interface IQMNewSalaryExportDepartments {
	id: number;
	users: {
		id: number;
	}[];
}

interface IQMIntegrationWithOptions {
	id: number;
	options: {
		[key: string]: boolean
	};
}

export interface IQMNewSalaryExportData {
	start: string;
	end: string;
	test: boolean;
	departments: IQMNewSalaryExportDepartments[];
	integrations: IQMIntegrationWithOptions[];
}

export interface IQMShiftCountData {
	start: string;
	end: string;
	departments: IQMNewSalaryExportDepartments[];
}
